<template>
    <a-drawer :title="title"
              :width="windowWidth >= 500 ? 500 : '95%'"
              :visible="visible"
              placement="right"
              forceRender
              @close="close">

        <template #extra>
            <a-button type="primary"
                      html-type="submit"
                      :disabled="loadings"
                      @click="submit">提交</a-button>
        </template>

        <a-spin :spinning="loadings">
            <a-form name="addProject"
                    ref="form"
                    layout="vertical"
                    :model="addForm"
                    :label-col="{ span: 8 }"
                    :wrapper-col="{ span: 24 }">
                <a-form-item label="任务类型名称"
                             name="name"
                             :rules="[{ required: true, message: '请输入任务类型名称' }]">
                    <a-input v-model:value="addForm.name"
                             placeholder="请输入任务类型名称"
                             show-count
                             :maxlength="255" />
                </a-form-item>

                <a-form-item label="任务类型描述"
                             name="desc"
                             :rules="[{ required: true, message: '请输入任务类型描述' }]">
                    <a-textarea show-count
                                placeholder="请输入任务类型描述"
                                v-model:value="addForm.desc"
                                :autoSize="{minRows: 3}"
                                :maxlength="255" />
                </a-form-item>

                <a-form-item label="适用工作项目"
                             name="project">
                    <a-select mode="multiple"
                              placeholder="请选择工作项目"
                              v-model:value="addForm.project"
                              :options="projectOptions"></a-select>
                </a-form-item>

                <a-form-item label="个性化字段"
                             name="custom">
                    <a-select mode="multiple"
                              placeholder="请选择个性化字段"
                              v-model:value="addForm.custom"
                              :options="customOptions"></a-select>
                </a-form-item>
            </a-form>
        </a-spin>
    </a-drawer>
</template>


<script>
    import { mapMutations, mapState } from 'vuex';

    import nui from '@/assets/script';

    export default {
        name: 'AddTaskTypeBox',
        props: {
            visible: { type: Boolean, default: false }
        },
        computed: {
            ...mapState(nui.extendVue.extendState.concat(['windowWidth'])),
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                title: '新建任务类型',

                loadings: false,

                customOptions: [],
                projectOptions: [],

                addForm: {
                    name: '',
                    desc: '',
                    custom: [],
                    project: []
                }
            })
        },
        watch: {
            visible: function () {
                // 避免外部添加数据，每次打开都重新获取一下
                if (this.visible) {
                    this.getData()
                }
            }
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat(['setWindowSize'])),

            NMounted () {

            },
            /**
             * @description 获取添加类型需要的数据
             */
            getData () {
                this.loadings = true;

                var dataPromise = [
                    this.request(this.API.taskCustomList),
                    this.request(this.API.myProject, {
                        method: 'post',
                        data: {
                            pageCount: 1,
                            pageSize: 9999999
                        }
                    })];

                Promise.all(dataPromise).then(res => {
                    if (res[0].code == this.REQUEST_SUCCESS_CODE) {
                        this.customOptions = res[0].data.map(item => {
                            return {
                                value: item.id,
                                label: item.fieldName
                            }
                        })
                    }

                    if (res[1].code == this.REQUEST_SUCCESS_CODE) {
                        this.projectOptions = res[1].data.list.map(item => {
                            return {
                                value: item.id,
                                label: item.projectName
                            }
                        })
                    }

                    this.loadings = false;
                })
            },
            /**
             * @description 获取任务类型
             */
            setData (id) {
                if (id) {
                    this.id = id;
                    this.loadings = true;

                    this.request(this.API.getTaskType, {
                        params: { taskTypeId: id }
                    }).then(res => {
                        if (res.code == this.REQUEST_SUCCESS_CODE) {
                            this.addForm = {
                                name: res.data.taskTypeName,
                                desc: res.data.label,
                                custom: res.data.fieldList.map(item => item.fieldId),
                                project: res.data.projectList.map(item => item.projectId)
                            }

                            this.title = '编辑任务类型'
                            this.loadings = false;
                        } else {
                            this.error(res.msg);
                        }
                    })
                } else {
                    this.id = null;
                    this.addForm = {
                        name: '',
                        desc: '',
                        custom: [],
                        project: []
                    }
                }
            },
            close () {
                this.reset()
                this.$emit('close')
            },
            reset () {
                this.addForm = {
                    name: '',
                    desc: '',
                    custom: [],
                    project: []
                }
            },
            submit () {
                this.$refs.form.validate().then(res => {
                    this.loadings = true;

                    this.request(this.id ? this.API.editTaskType : this.API.addTaskType, {
                        method: 'post',
                        data: {
                            id: this.id,
                            taskTypeName: this.addForm.name,
                            label: this.addForm.desc,
                            projectIdList: this.addForm.project,
                            fieldIdList: this.addForm.custom
                        }
                    }).then(res => {
                        if (res.code == this.REQUEST_SUCCESS_CODE) {
                            this.success(this.id ? '编辑成功' : '添加成功')
                            this.$emit('success')
                            this.$emit('close')
                            this.reset()
                        } else {
                            this.error(res.msg);
                        }

                        this.loadings = false;
                    }).catch(err => {
                        this.loadings = false;
                    })
                })
            }
        }),
        components: {
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss" scoped>
</style>